<template>
    <div>
        <div class="col-lg-8 px-0 mt-4">
            <ul class="input-table">
                <li
                    class="d-flex justify-content-start"
                    v-if="items.length"
                    v-for="(item, index) in filteredItems"
                    :key="item.id"
                >
                    <div class="pr-2 d-flex align-items-center">
                        <core-icon
                            v-if="index !== selectedIndex"
                            @click.native="selectItem(index)"
                            class="pointer"
                            :iconName="$t('services.info.navigation.schedule.load-period-times')"
                            iconColor="#bdbdbd"
                        >
                            <icons-clock></icons-clock>
                        </core-icon>
                        <core-icon
                            v-else
                            class="pointer"
                            :iconName="$t('services.info.navigation.schedule.load-period-times')"
                            iconColor="#008CDD"
                        >
                            <icons-clock-check-outline></icons-clock-check-outline>
                        </core-icon>
                    </div>
                    <div class="input-table-shadow">
                        <div class="d-flex row align-items-center">
                            <div class="col-4 border-right">
                                <core-calendar
                                  class="pl-3"
                                  :date.sync="item.dateFrom"
                                  :inputProps="{placeholder: 'Start date', readonly: 'readonly'}"
                                ></core-calendar>
                            </div>
                            <div class="col-4 border-right">
                                <core-calendar
                                  :date.sync="item.dateUntil"
                                  :inputProps="{placeholder: 'End date', readonly: 'readonly'}"
                                  :minDate="item.dateFrom"
                                  :key="item.dateUntil"
                                ></core-calendar>
                            </div>
                            <div class="col-4">
                                <core-days-modal-picker
                                    :days.sync="item.days"
                                ></core-days-modal-picker>
                            </div>
                        </div>
                    </div>
                    <div class="pl-2 d-flex align-items-center">
                        <core-icon
                            @click.native="clone(item)"
                            class="pointer"
                            :iconName="$t('general.clone')"
                            iconColor="#bdbdbd"
                        >
                            <icons-clone></icons-clone>
                        </core-icon>
                    </div>
                    <div class="pl-1 d-flex align-items-center">
                        <core-icon
                            @click.native="remove(index)"
                            class="pointer"
                            :iconName="$t('general.remove')"
                            iconColor="#bdbdbd"
                        >
                            <icons-delete></icons-delete>
                        </core-icon>
                    </div>
                </li>
            </ul>
        </div>
        <img
            class="ml-3 add-row"
            src="@/assets/svg/plus008CDD.svg"
            @click="add({outbound: outbound, days: '0000000', transportTimes: []})"
            :title="$t('general.add')"
        >
    </div>
</template>

<script>
import { addItem } from '@/mixins/addItem'
import { cloneItem } from '@/mixins/cloneItem'
import { removeItem } from '@/mixins/removeItem'

export default {
  props: {
    transportTimePeriods: {
      type: Array,
      required: true
    },
    outbound: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      items: this.transportTimePeriods,
      searchQuery: null,
      selectedIndex: 0
    }
  },
  mixins: [addItem, cloneItem, removeItem],
  computed: {
    filteredItems () {
      let filteredItems = []
      if (this.outbound) {
        this.items.forEach((item) => {
          let isOutbound = !!+item.outbound
          if (isOutbound) {
            filteredItems.push(item)
          }
        })
      } else {
        this.items.forEach((item) => {
          let isOutbound = !!+item.outbound
          if (!isOutbound) {
            filteredItems.push(item)
          }
        })
      }
      return filteredItems
    }
  },
  created () {
    this.selectItem(this.selectedIndex)
  },
  methods: {
    selectItem (index) {
      this.selectedIndex = index
      this.$emit('select', index)
    }
  },
  watch: {
    items: {
      handler (val) {
        this.$emit('update:transportTimePeriods', val)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/service/schedule/TransportTimePeriod.vue